import {faEye, faEyeSlash} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import classnames from 'classnames'
import * as React from 'react'
import type {IProvideLabeledLineTextInputProps} from '~/components/FormFields/ProvideLabeledLineTextInput'
import ProvideLabeledLineTextInput from '~/components/FormFields/ProvideLabeledLineTextInput'
import type {HTMLInputType} from '~/components/ProvideForm/types'
import styles from './styles.module.css'

export interface ILabeledLineTextInputProps extends IProvideLabeledLineTextInputProps {
  inputType?: HTMLInputType
}

interface IState {
  revealed: boolean
}

export default class LabeledLineTextInput extends React.Component<
  ILabeledLineTextInputProps,
  IState
> {
  state: IState = {revealed: false}

  render() {
    const {inputType, ...provideInputProps} = this.props

    const revealable = inputType === 'password'
    const effectiveType =
      revealable && this.state.revealed ? 'text' : inputType || 'text'

    return (
      <ProvideLabeledLineTextInput
        {...provideInputProps}
        toInput={inputProps => {
          const input = (
            <input
              key="input"
              {...inputProps}
              className={classnames(styles.input, inputProps.className)}
              type={effectiveType}
              ref={provideInputProps.inputRef as React.Ref<HTMLInputElement>}
            />
          )

          if (!revealable) {
            return input
          }

          return [
            input,
            <RevealButton
              key="reveal"
              revealed={this.state.revealed}
              onToggle={() => this.setState(prev => ({revealed: !prev.revealed}))}
            />,
          ]
        }}
      />
    )
  }
}

function RevealButton(props: {revealed: boolean; onToggle: () => void}) {
  return (
    <button
      type="button"
      className={styles.revealButton}
      // Keep focus in the input when toggling.
      onMouseDown={e => e.preventDefault()}
      onClick={props.onToggle}
      aria-label={props.revealed ? 'Hide password' : 'Show password'}
      aria-pressed={props.revealed}
    >
      <FontAwesomeIcon icon={props.revealed ? faEyeSlash : faEye} />
    </button>
  )
}
